import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from 'react-redux';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { addRegistrationDetails } from "../../store/actions/AuthActions";
import { Modal, Button } from "react-bootstrap";
import axiosInstance from "../../services/AxiosInstance";
import './registration.css';
import '../../css/recaptcha.css';
import { Footer, RegisterHero } from "../components";
import { saveTokenInLocalStorage, saveUserDataLocalStorage } from '../../services/AuthService';
import ReCaptchaComponent from '../components/ReCaptcha';

function Register(props) {

  const [formData, setFormData] = useState({
    CorporateName: "",
    CorporateEmail: "",
    PhoneNumber: "",
    CorporatePassword: "",
    RetypePassword: "",
    selectedMobileCode: '',
    termsandconditions: false,
    CorporateUserName: ""
  });
  const [countries, setCountries] = useState([]);
  const [selectedMobileCode, setSelectedMobileCode] = useState("");
  const [errors, setErrors] = useState({});
  const countryOptions = countries.map(country => ({
    value: country.ID,
    label: `${country.CountryName} (${country.CountryCode})`,
    CountryCode: country.CountryCode
  }));
  const [basicModal, setBasicModal] = useState(false);
  const [otp, setOtp] = useState()
  const [otpError, setOtpError] = useState("");
  const [resendTimer, setResendTimer] = useState(0);
  const [resultObject, setResultObject] = useState()
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false); 
  const [otpPending, setOtpPending] = useState(false); // Track if OTP is pending
  const [showPassword, setShowPassword] = useState(false);
  const [resendAttempts, setResendAttempts] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  // reCAPTCHA states
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState("");
  const recaptchaRef = useRef(null);

  // reCAPTCHA configuration - Replace with your actual site key
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"; // This is a test key
  const RECAPTCHA_ACTION = 'registration'; // Action name for v3


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    const userType = params.get("userType");
    if (email && userType) {
      setResultObject({
        email,
        usertype: userType,
      });
      setBasicModal(true); // Show OTP modal automatically
      setOtpPending(true); // Mark OTP as pending
      setResendAttempts(false); // Reset resend attempts counter
    }
  }, [location.search]);
  const notifyTopRight = (data) => {
    toast.success(`✔️ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };
  const notifyError = (data) => {

    toast.error(`❌ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,

    });
  };

  // reCAPTCHA handlers
  const handleRecaptchaVerify = (token) => {
    if (!token) {
      setRecaptchaError("reCAPTCHA verification failed. Please try again.");
      setLoading(false);
      return;
    }
    
    setRecaptchaToken(token);
    setRecaptchaError("");
    
    // Submit the form with the token
    submitFormWithToken(token);
  };

  const handleRecaptchaExpire = () => {
    setRecaptchaToken(null);
    setRecaptchaError("reCAPTCHA has expired. Please refresh the page and try again.");
    setLoading(false);
  };

  const handleRecaptchaError = (error) => {
    setRecaptchaToken(null);
    setRecaptchaError("reCAPTCHA verification failed. Please refresh the page and try again.");
    setLoading(false);
  };

  useEffect(() => {
    const fetchCountries = async () => {

      try {
        const res = await axiosInstance.get(`/auth/countrylist`);

        const data = res.data;
        setCountries(data);
      } catch (err) {
        console.error("Failed to fetch countries:", err);
      }
    };

    fetchCountries();
  }, []);


  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));

    if (name === "CountryId") {
      const selected = countries.find((c) => String(c.id) === value);
      if (selected) {
        setSelectedMobileCode(selected.phone_code || "");
      }
    }

    // Clear reCAPTCHA error when user starts typing
    if (recaptchaError) {
      setRecaptchaError("");
    }
  };

  // Returns true if string contains only special characters (no letters or digits)
  const isOnlySpecialChars = (str) => {
    const trimmed = (str || "").trim();
    if (!trimmed) return false;
    return !/[a-zA-Z0-9]/.test(trimmed);
  };

  const validate = () => {
    const newErrors = {};

    if (formData.CorporateName.trim() && isOnlySpecialChars(formData.CorporateName)) {
      newErrors.CorporateName = "Company name cannot contain only special characters.";
    }

    if (!formData.CorporateEmail.trim()) {
      newErrors.CorporateEmail = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.CorporateEmail)) {
      newErrors.CorporateEmail = "Email is invalid.";
    }

    if (!formData.PhoneNumber.trim()) newErrors.PhoneNumber = "Phone Number is required.";

    if (!formData.CorporatePassword.trim()) {
      newErrors.CorporatePassword = "Password is required.";
    } else {
      if (formData.CorporatePassword.length < 8) {
        newErrors.CorporatePassword = "Password must be at least 8 characters long.";
      } else if (!/[A-Z]/.test(formData.CorporatePassword)) {
        newErrors.CorporatePassword = "Password must contain at least one uppercase letter.";
      } else if (!/[a-z]/.test(formData.CorporatePassword)) {
        newErrors.CorporatePassword = "Password must contain at least one lowercase letter.";
      } else if (!/[0-9]/.test(formData.CorporatePassword)) {
        newErrors.CorporatePassword = "Password must contain at least one number.";
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(formData.CorporatePassword)) {
        newErrors.CorporatePassword = "Password must contain at least one special character.";
      }
    }

    if (!formData.RetypePassword.trim()) {
      newErrors.RetypePassword = "Retype Password is required.";
    } else if (formData.CorporatePassword !== formData.RetypePassword) {
      newErrors.RetypePassword = "Passwords do not match.";
    }

    if (!formData.CountryId) {
      newErrors.CountryId = "Country is required.";
    }

    if (!formData.termsandconditions) {
      newErrors.termsandconditions = "You need to tick the checkbox.";
    }

    if (!formData.CorporateUserName.trim()) {
      newErrors.CorporateUserName = "Full Name is required.";
    } else if (isOnlySpecialChars(formData.CorporateUserName)) {
      newErrors.CorporateUserName = "Full name cannot contain only special characters.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }
    
    setLoading(true);
    setRecaptchaError("");
    
    // Execute reCAPTCHA on form submit
    if (recaptchaRef.current) {
      recaptchaRef.current.execute();
    } else {
      setRecaptchaError("reCAPTCHA verification failed. Please refresh the page and try again.");
      setLoading(false);
    }
  };

  const submitFormWithToken = async (token) => {
    const selectedCountry = countries.find(
      (c) => String(c.id) === formData.CountryId
    );
    const payload = {
      ...formData,
      CountryName: selectedCountry?.name || "",
      PhoneNumber: `${selectedMobileCode}${formData.PhoneNumber}`,
      CorporateDomain: null,
      recaptchaToken: token, // Include reCAPTCHA token
      recaptchaAction: RECAPTCHA_ACTION // Include action for v3
    };

    try {
      const res = await axiosInstance.post(`/auth/corporate/add`, payload);
      console.log(res)

      if (res.data.success === true) {
        const object = {
          corporateid: res.data.corporateID,
          email: formData["CorporateEmail"],
          usertype: "Corporate"
        };


        console.log("object", object)

        if (object != '') {
          setResultObject(object);
          generateOtp(object)
          // Reset reCAPTCHA after successful submission
          if (recaptchaRef.current) {
            recaptchaRef.current.reset();
            setRecaptchaToken(null);
          }
        }
      }
      else {
        console.log(res.data.error)
        notifyError(res.message)
        setLoading(false);
        // Reset reCAPTCHA on error
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
          setRecaptchaToken(null);
        }
      }
    } catch (err) {
      if (err && err.response && err.response.status === 409) {
        notifyError('This email address is already registered.');
      } else if (err) {
        notifyError(err.response?.data?.message || err.response?.data?.error || 'An error occurred.');
      }
      setLoading(false);
      // Reset reCAPTCHA on error
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
        setRecaptchaToken(null);
      }
    }
  };

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendTimer]);

  const generateOtp = async (resultobject) => {
    console.log(resultobject)
    const object = {
      email: resultobject.email,
      corporateid: resultobject.corporateid,
      usertype: resultobject.usertype,
      userid: resultobject.userid,
    };

    try {
      const res = await axiosInstance.post(`/auth/generate-otp`, object);

      console.log(res)
      if (res.data.message == 'OTP has been sent to your email') {
        setBasicModal(true)
        setResendTimer(30); // Start 30s countdown
        setResendAttempts(false); // Reset resend attempts counter for new OTP
        notifyTopRight(res.data.message || 'OTP generation failed.');
        setLoading(false); // Stop loading after modal is shown
      }

      else {
        notifyError(res.data.message)
        setLoading(false); // Stop loading on error
      }
    } catch (err) {
      if(err.response && err.response.status === 409) {
        notifyError('OTP Limit Reached');
        setResendAttempts(true);
      }
      setLoading(false); // Stop loading on error
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    if (!otp || otp.trim() === "") {
      setOtpError("Please enter OTP.");
      return;
    }
    setOtpError("");
    setOtpLoading(true);
    const object = {
      email: resultObject.email,
      otp: parseInt(otp),
      usertype: resultObject.usertype,
    };
    try {
      const res = await axiosInstance.post(`/auth/verify-otp`, object);

      const data = res.data;
      console.log(res)
      if (data.message == "OTP Verified Successfully, Account Activated") {
        toast.success("Registered successfully")
        saveTokenInLocalStorage(data.accessToken, true);
        saveUserDataLocalStorage(data.user);
        const urlParams = new URLSearchParams(location.search);
        const planId = urlParams.get('plan');
        if (planId) {
          const response = await axiosInstance.post('/userSubscription/subscribe', {
            subscription_plan_id: planId
          });
          if (response.data) {
            toast.success('Subscription created successfully!');

            // Clear selected plan from session storage
            sessionStorage.removeItem('selectedPlan');

            // Navigate to dashboard or next step
            setTimeout(() => {
              navigate('/task/tasklist');
            }, 2000);
          } else {
            toast.error(response.data?.message || 'Failed to create subscription');
          }
        } else {
          const urlParams = new URLSearchParams(location.search);
          const moduleParam = urlParams.get('module');
          const queryString = (moduleParam === 'task' || moduleParam === 'document') ? `?module=${moduleParam}` : '';
          setTimeout(() => {
            navigate('/registration-subscription' + queryString);
          }, 2000);
        }

      } else {
        notifyError(data.message);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          toast.error('Invalid or expired OTP');
        } else {
          toast.error(err.response.data.error);
        }
      }
    } finally {
      setOtpLoading(false); // Stop loading regardless of success or error
    }
  };

  const handleResendOtp = () => {
    setResendTimer(30); // restart countdown
    generateOtp(resultObject);
  };


  return (
    <div className="authincation d-flex flex-column flex-column-fluid">
      <ToastContainer />
      <RegisterHero />

      <div className="flex-row-fluid d-flex flex-column align-items-center position-relative overflow-hidden" style={{ minHeight: '100vh' }}>
        <div className="w-100 flex justify-content-center" style={{ maxWidth: 700 }}>
          <div className="authincation-content">
            <div className="row no-gutters">
              <div className="col-xl-12">
                <div className="auth-form" style={{ padding: '1.5rem 3.125rem' }}>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-xl-12 form-group mb-3">
                        <label className="mb-1"><strong>Your Company Name</strong></label>
                        <input
                          type="text"
                          name='CorporateName'
                          className="form-control"
                          placeholder="Your Company Name"
                          defaultValue={formData.CorporateName}
                          onChange={handleChange}
                        />
                        {errors.CorporateName && <div className="text-danger">{errors.CorporateName}</div>}
                      </div>

                    </div>
                    <div className="row">
                      <div className="col-xl-6 form-group mb-3">
                        <label className="mb-1"><strong>Email*</strong></label>
                        <input
                          type="email"
                          name="CorporateEmail"
                          className="form-control"
                          placeholder="Email"
                          defaultValue={formData.CorporateEmail}
                          onChange={handleChange}
                        />
                        {errors.CorporateEmail && <div className="text-danger">{errors.CorporateEmail}</div>}
                      </div>
                      <div className="col-xl-6 form-group mb-3">
                        <label className="mb-1"><strong>Full Name*</strong></label>
                        <input
                          type="text"
                          name="CorporateUserName"
                          className="form-control"
                          onChange={handleChange}
                          placeholder="Full Name"
                          defaultValue={formData.CorporateUserName}
                        />
                        {errors.CorporateUserName && <div className="text-danger">{errors.CorporateUserName}</div>}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-6 form-group mb-3">
                        <label className="mb-1"><strong>Country*</strong></label>
                        <select
                          ref={(el) => (window.countrySelect = el)} // temporary global ref or useRef
                          className="form-control"
                          id="CountrySelect"
                          name="CountryId"
                          value={formData.CountryId}
                          onChange={handleChange}
                        >
                          <option value="">-- Select a country --</option>
                          {countries.map((country) => (
                            <option key={country.id} value={country.id}>
                              {country.name} ({country.phone_code})
                            </option>
                          ))}
                        </select>
                        {errors.CountryId && <div className="text-danger">{errors.CountryId}</div>}
                      </div>

                      <div className="col-xl-6 form-group mb-3 d-flex align-items-end">
                        <div className="w-100 flex flex-column gap-2" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                          <label className="mb-1"><strong>Mobile Number*</strong></label>
                          <div className="input-group ">
                            <span
                              className="phonecode"
                              onClick={() => {
                                // Try to focus the select input for countries
                                document.getElementById('CountrySelect')?.focus();
                              }}
                              style={{ cursor: 'pointer' }}
                              title="Click to select country"
                            >
                              {selectedMobileCode}
                            </span>
                            <input
                              type="number"
                              id="PhoneNumberInput"
                              name="PhoneNumber"
                              className="form-control"
                              onChange={handleChange}
                              placeholder="Phone Number"
                            />
                          </div>

                          {errors.PhoneNumber && <div className="text-danger">{errors.PhoneNumber}</div>}
                        </div>
                      </div>


                    </div>
                    <div className="row">
                      <div className=" col-xl-6 form-group mb-3">
                        <label className="mb-1"><strong>Password</strong></label>
                        <div className="position-relative password-input-wrapper">
                          <input
                            type={showPassword ? "text" : "password"}
                            name='CorporatePassword'
                            className="form-control"
                            placeholder="Password"
                            defaultValue={formData.CorporatePassword}
                            onChange={handleChange}
                          />
                          <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                          </button>
                        </div>
                        {errors.CorporatePassword ? <div className="text-danger">{errors.CorporatePassword}</div> :
                          <div className="password-info">Password must be at least 8 characters long and contain at least one uppercase letter, one number, and one special symbol.</div>}
                      </div>

                      <div className="col-xl-6 form-group mb-3">
                        <label className="mb-1"><strong>Retype Password</strong></label>
                        <div className="position-relative password-input-wrapper">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="RetypePassword"
                            className="form-control"
                            placeholder="Retype Password"
                            defaultValue={formData.RetypePassword}
                            onChange={handleChange}
                          />
                          <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          >
                            <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                          </button>
                        </div>
                        {errors.RetypePassword && <div className="text-danger">{errors.RetypePassword}</div>}
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <label
                        className="form-check css-control-primary css-checkbox"
                        htmlFor="termsandconditions"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input me-2 mt-0"
                          id="termsandconditions"
                          name="termsandconditions"
                          checked={formData.termsandconditions}
                          onChange={handleChange}
                        />
                        <span className="css-control-indicator"></span> Agree to{" "}
                        <Link
                          to="/terms-and-conditions"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="terms-link text-primary hover:underline focus:underline focus:outline-none focus:ring-2 focus:ring-primary rounded"
                        >
                          terms and conditions
                        </Link>
                      </label>


                      {errors.termsandconditions && <div className="text-danger">{errors.termsandconditions}</div>}
                    </div>
                    <div className="col-lg-12 mt-2" style={{ paddingLeft: "1.8rem" }}>
                      <p style={{ fontSize: '0.85rem', color: 'gray' }}>
                        Once submitted, we will send an OTP to your email address. Your account will be only setup once the OTP is verified
                      </p>
                    </div>
                    
                    {/* reCAPTCHA v3 Component - Invisible */}
                    <div className="col-lg-12">
                      <ReCaptchaComponent
                        ref={recaptchaRef}
                        siteKey={RECAPTCHA_SITE_KEY}
                        version="v3"
                        action={RECAPTCHA_ACTION}
                        onVerify={handleRecaptchaVerify}
                        onExpire={handleRecaptchaExpire}
                        onError={handleRecaptchaError}
                        autoExecute={false}
                      />
                      {errors.recaptcha && <div className="text-danger text-center mt-2">{errors.recaptcha}</div>}
                      {recaptchaError && <div className="text-danger text-center mt-2">{recaptchaError}</div>}
                    </div>
                    
                    <div className="text-center mt-4">
                      <div className="d-flex w-100 justify-content-center">
                        <button
                          type="submit"
                          className="auth-button-submit"
                          disabled={loading || (otpPending && !basicModal)}
                          style={{ maxWidth: '250px' }}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          ) : null}
                          Register my Account
                        </button>
                      </div>
                    </div>


                    {/* <!-- Modal --> */}
                    <Modal className="fade" show={basicModal}>
                      <Modal.Header>
                        <Modal.Title>Verify OTP</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p>Please check your email address to get the OTP. Do check the spam folder as well.</p>
                        <div className="form-group mb-3">
                          <label className="mb-1"><strong>Enter OTP</strong></label>
                          <input
                            type="number"
                            className="form-control otp-input"
                            placeholder="otp"
                            value={otp}
                            onChange={(e) => {
                              setOtp(e.target.value);
                              if (otpError) setOtpError("");
                            }}
                          />
                          {otpError && <div className="text-danger">{otpError}</div>}
                        </div>
                        <div className="text-left mt-4 mb-2">The OTP will expire in 5 minutes</div>
                        <div className="text-left">
                          OTP not received yet?{" "}
                          <Link
                            to="#"
                            className={`resend-otp ${resendTimer > 0 || resendAttempts ? 'disabled' : ''}`}
                            onClick={resendTimer > 0 || resendAttempts ? (e) => e.preventDefault() : handleResendOtp}
                            style={{ 
                              pointerEvents: resendTimer > 0 || resendAttempts ? 'none' : 'auto', 
                              color: resendTimer > 0 || resendAttempts ? 'gray' : '' 
                            }}
                          >
                            {resendTimer > 0 ? `Resend OTP (${resendTimer}s)` : "Resend OTP"}
                          </Link>
                        </div>
                      </Modal.Body>
                      <Modal.Footer style={{ justifyContent: 'center' }}>
                        <button
                          className="otp-submit-btn"
                          onClick={verifyOtp}
                          disabled={otpLoading}
                        >
                          {otpLoading ? (
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          ) : null}
                          Verify OTP
                        </button>
                      </Modal.Footer>
                    </Modal>
                    {/* Show Verify OTP button if OTP is pending and modal is closed */}
                    {otpPending && !basicModal && (
                      <div className="text-center mt-2" style={{ fontSize: '0.85rem' }}>
                        Didn't complete verification?{' '}
                        <span
                          style={{ color: '#00A15D', textDecoration: 'underline', cursor: 'pointer', padding: '0 2px', fontSize: '0.85rem' }}
                          onClick={() => setBasicModal(true)}
                        >
                          Verify OTP
                        </span>
                      </div>
                    )}
                  </form>

                  <div className="alreadyaccountlink new-account mt-3">
                    <p className="">
                      Already have an account?{" "}
                      <Link className="text-primary" to="/login">
                        Sign in
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>



  );
};

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
    registrationDetails: state.registrationDetails
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addRegistrationDetails
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);

